// extracted by mini-css-extract-plugin
export default {"container":"aQWPNF","titleRow":"ThhoO2","title":"JxwhQq","viewItems":"olizpv","spreadRow":"FT1Trl","total":"r4MKwh"};